import React from 'react'
import { PokerGameModel, UserProfileModel } from 'mvppoker-portal-common/api'
import { Chat, Circle, GamesOutlined, GamesRounded, Info } from '@mui/icons-material'
import { CgDollar } from 'react-icons/cg'
import { MVPButton } from '../../Buttons/MVPButton'
import './FriendsListItem.scss'

export interface FriendsListItemActions
{
	clickFriend: (friend: UserProfileModel) => void,
    showFollowToGame: boolean,
	clickFollowToGame: (friend: UserProfileModel) => void,
    showGameInvite: boolean,
	clickGameInvite: (friend: UserProfileModel) => void,
    showChat: boolean,
	clickChat: (friend: UserProfileModel) => void,
    showTransferFunds: boolean,
    clickTransferFunds: (friend: UserProfileModel) => void,
}
export interface FriendsListItemProps extends FriendsListItemActions
{
	friend: UserProfileModel,
    rooms: { [roomId: string] : PokerGameModel },
    hasUnreadChat: boolean,
}

function isInRoom(friend: UserProfileModel)
{
    return friend.info.currentRoom !== undefined
}
function getRoomInfo(friend: UserProfileModel, rooms: { [roomId: string] : PokerGameModel }) : string
{
    if (isInRoom(friend)){
        const room = rooms[friend.info.currentRoom!]
        if (room){
            return `PLAYING IN\n${room.config.roomName}`
        }
    }
    return ''
}

export const FriendsListItem: React.FC<FriendsListItemProps> = ({ friend, rooms, hasUnreadChat, clickFriend, showFollowToGame, clickFollowToGame, showGameInvite, clickGameInvite, showChat, clickChat, showTransferFunds, clickTransferFunds }) =>
{
    const { avatar, isOnline } = friend.info
    const roomInfo = getRoomInfo(friend, rooms)

	return (
		<div className='friends-list-item mvp-list-item'>
                <div id="col1" className='column'>
                    <img id='user-avatar' className='avatar' src={avatar} alt='avatar'/>
				    <p className={isOnline ? 'online' : 'offline'} style={{ height:'20%', marginTop:'5px' }}>{ isOnline ? 'ONLINE' : 'OFFLINE'}</p>
                </div>
                <div id="col2" className='column'>
                    <p className='big'>{friend.info.name}</p>
                    <p className='small' >{roomInfo}</p>
                </div>
                <div id="col3" className='row'>
                    {showTransferFunds && <MVPButton id='transfer-funds-button' className='friends-button' onClick={() => clickTransferFunds(friend)}>
					    <CgDollar />
                        TRANSFER FUNDS
				    </MVPButton>}
                    {showFollowToGame && <MVPButton id='follow-to-game-button' className='friends-button' onClick={() => clickFollowToGame(friend)} disabled={!isInRoom(friend)}>
					    <GamesRounded />
                        FOLLOW TO GAME
				    </MVPButton>}
                    {showGameInvite && <MVPButton id='game-invite-button' className='friends-button' onClick={() => clickGameInvite(friend)}>
					    <GamesOutlined />
                        INVITE TO GAME
				    </MVPButton>}
                    {showChat && <MVPButton id='chat-button' className='friends-button' onClick={() => clickChat(friend)} disabled={!isOnline}>
					    <Chat />
                        CHAT
                        {hasUnreadChat && <Circle className='indicator' color='error'/>}
				    </MVPButton>}
                    <MVPButton id='friend-info-button' className='friends-button' onClick={() => clickFriend(friend)} >
					    <Info />
                        Info
				    </MVPButton>
                </div>
		</div>
	)
}
